import { combineReducers } from 'redux';
import currentUserReducer from './user.reducer';
import reportsReducer from './reportingDashboard.reducer';
import dashboardReducer from './dashboard.reducer';
import routingReducer from './routing.reducer';
import stateReducer from './state.reducer';
import participantReducer from './participant.reducer';
import cardSetReducer from './cardSet.reducer';
import UpdateReportReducer from './updateReport.reducer';
import dashboardCountReducer from './dashboardCount.reducer';
import reportingDashboardCountReducer from './reportingDashboardCount.reducer';

const rootReducer = combineReducers({
	currentUser: currentUserReducer,
	reportsState: reportsReducer,
	dashboardState: dashboardReducer,
	routeState: routingReducer,
	stateState: stateReducer,
	participantState: participantReducer,
	cardSetState: cardSetReducer,
	updateReportState: UpdateReportReducer,
	dashboardCountState: dashboardCountReducer,
	reportingDashboardCountState: reportingDashboardCountReducer,
});

export default rootReducer;
